import React, { Fragment } from "react"; 
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts/LayoutOne";  
import ServiceDetails from "../templates/OffreSingle/index";

const offreePage = () => {
	return (
	  <Fragment>
		<MetaTags>
		  <title> SAPIT </title>
		  <meta
			name="description"
			content=" SAPIT "
		  />
		</MetaTags> 
		<LayoutOne>

		    <ServiceDetails />

		</LayoutOne>
	  </Fragment>
	);
  };
  
  export default offreePage;



